import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "results-count",
  class ResultsCount extends SearchspringComponent {
    constructor() {
      super();

      this.template = this.querySelector('[data-template="results-count"]');
    }

    render({ pagination }) {
      if (!pagination) {
        return;
      }

      const { totalResults } = pagination;

      const resultsCount = this.template.content.cloneNode(true);
      const count = resultsCount.querySelector(
        '[data-template-element="count"]',
      );

      count.textContent = totalResults;

      this.appendChild(resultsCount);
    }
  },
);
